var handlerReferences = {
  $selectContainer: $('.select-container'),
  $selectOptions: $('.select-option'),
  $selectSelected: $('.selected-label'),
  $subnavs: $('.subnav'),
  $referenceContainers: $('.reference-content-container'),
  selectReference: function($reference) {
    var reference = $reference.data('term');
    this.$subnavs.addClass('hide');
    this.$subnavs.filter('[data-term="'+reference+'"]').removeClass('hide');
    this.$referenceContainers.addClass('hide');
    this.$referenceContainers.filter('[data-term="'+reference+'"]').removeClass('hide');
    $('html, body').animate({
      scrollTop: 0
    }, 250);
    this.highlightSubnav();
  }, 
  selectResearch: function($research) {
    // $research is subnav item
    var $target = $($research.attr('href'));
    if ($target) {
      handlerNavigation.scrollIntoView($target);
    }
  },
  highlightSubnav: function() {
    var $currentResearch = null;
    var scrollTop = $window.scrollTop();
    var headerHeight = $header.outerHeight();
    var $targetSubnav = null;
    $(this.$referenceContainers.filter(':visible').find('> div').get().reverse()).each(function() {
      if ($(this).offset().top - headerHeight - 1 <= scrollTop) {
        $currentResearch = $(this);
        return false;
      }
    });
    if ($currentResearch == null) {
      $targetSubnav = this.$subnavs.filter(':visible').find('.subnav-item').eq(0);
    } else {
      $targetSubnav = this.$subnavs.filter(':visible').find('.subnav-item a[href="#'+$currentResearch.attr("id")+'"]').parent();
    }
    if ($targetSubnav) {
      this.$subnavs.find('.subnav-item').removeClass('highlighted');
      $targetSubnav.addClass('highlighted');
    }
  },
  init: function() {
    var self = this;
    this.$selectOptions.on("click", function() {
      self.selectReference($(this).closest('.select-option'));
    });
    this.$subnavs.find('a').on("click", function(event) {
      event.preventDefault();
      self.selectResearch($(this));
    });
    $window.on("scroll", function() {
      self.highlightSubnav();
    });
  },
};

jQuery(document).ready(function($) {
  if ($('body.page-template-page-references').length > 0) {
    var referenceParam = getUrlParameter('reference');
    var researchParam = getUrlParameter('res');
    handlerReferences.init();
    if (!referenceParam) {
      referenceParam = handlerReferences.$selectOptions.eq(0).data('term');
    }
    if (referenceParam) {
      handlerReferences.$selectOptions.filter('[data-term="'+referenceParam+'"]').trigger("click");
    }
    if (researchParam) {
      var $subnavItem = handlerReferences.$subnavs.find('.subnav-item a[href="#'+researchParam+'"]');
      if ($subnavItem.length > 0) {
        handlerReferences.$selectOptions.filter('[data-term="'+$subnavItem.data('term')+'"]').trigger("click");
        handlerReferences.selectResearch($subnavItem);
      }
    }
    handlerReferences.highlightSubnav();
    handlerNavigation.resetSelectOptionsHeight();
  }
});
